import React from 'react';
import { ResponsiveBar } from '@nivo/bar';

const StatusComparisonChart = ({ items = [], palette = {} }) => {
  if (!items.length) {
    return <div className="status-report-empty">No activity in this period.</div>;
  }

  return (
    <div className="status-report-comparison-chart">
      <ResponsiveBar
        data={items.map((item) => ({ label: item.name, current: item.current, prior: item.prior }))}
        keys={['current', 'prior']}
        indexBy="label"
        margin={{ top: 8, right: 22, bottom: 34, left: 122 }}
        padding={0.3}
        innerPadding={2}
        groupMode="grouped"
        layout="horizontal"
        colors={[palette.chartCurrent || '#2C9C91', palette.chartPrior || '#DCE4EC']}
        borderWidth={1}
        borderColor={palette.chartBorder || palette.chartCurrent || '#2C9C91'}
        enableLabel={false}
        enableGridY={false}
        axisLeft={{
          tickSize: 0,
          tickPadding: 8,
          format: (value) => value?.length > 20 ? `${value.substring(0, 20)}...` : value,
        }}
        axisBottom={{ tickSize: 0, tickPadding: 8, format: (value) => Number.isInteger(value) ? value : '' }}
        animate={false}
        theme={{
          fontFamily: 'Inter, Montserrat, sans-serif',
          fontSize: 10,
          textColor: 'var(--app-text-muted)',
          axis: { ticks: { text: { fill: 'var(--app-text-muted)' } } },
          grid: { line: { stroke: 'var(--app-border)' } },
          tooltip: {
            container: {
              background: 'var(--app-surface)',
              color: 'var(--app-text)',
              border: '1px solid var(--app-border)',
            },
          },
        }}
      />
    </div>
  );
};

export default StatusComparisonChart;
